"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _icon = _interopRequireDefault(require("../icon"));

var _nav = _interopRequireDefault(require("./nav.scss"));

var AccountMenu = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(AccountMenu, _Component);

  function AccountMenu() {
    var _this;

    (0, _classCallCheck2["default"])(this, AccountMenu);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(AccountMenu).call(this));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleClick", function (e) {
      e.preventDefault();

      _this.toggleActive();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "toggleActive", function () {
      return _this.setState({
        active: !_this.state.active
      });
    });
    _this.state = {
      active: false
    };
    return _this;
  }

  (0, _createClass2["default"])(AccountMenu, [{
    key: "render",
    value: function render() {
      return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("a", {
        href: "#",
        onClick: this.handleClick
      }, "Account ", _react["default"].createElement(_icon["default"], {
        type: "chevron-down",
        className: _nav["default"].accountLink
      })), _react["default"].createElement("ul", {
        className: (0, _classnames["default"])(_nav["default"].accountMenu, this.state.active && _nav["default"].visible)
      }, this.props.items.map(function (el, i) {
        return _react["default"].createElement("li", null, _react["default"].createElement("a", {
          href: el.url,
          key: i
        }, el.title));
      })));
    }
  }]);
  return AccountMenu;
}(_react.Component);

AccountMenu.propTypes = {
  items: _propTypes["default"].array
};
var _default = AccountMenu;
exports["default"] = _default;